<template>
<div>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">
<ContentHeader title="Yeni Kullanıcı"  url="Users" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<div class="content_card_content">
<form @submit.prevent="submitForm" >


<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>


<FileUpload name="cover_image[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin" accept="image/*" :maxFileSize="1000000" class="">
  <template #empty>
      <p>Dosyayı sürükleyip bırakın</p>
  </template>
</FileUpload>



<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>
</div>


</div>

</div>
</template>

<script>
export default {

  name: 'CreateBrand',

  data () {
    return {
      submitted: false,
      files:[],
      fields:[
      {
        title:"İsim",
        key:"name",
        type:"text",
        value:null,
        min_length:2,
        max_length:50,
        is_required:true,
        has_error:false,
        error_message:null,
      },
      ]
    }
  },
  mounted()
  {

  },
  methods:{
    onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
    submitForm()
    {
        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false     
    },
    submit()
    {         
      let formdata = this.createFormData(this.fields)
      //formdata.append('cover_image', this.files);

      for( var i = 0; i < this.files.length; i++ ){
        let file =  this.files[i];
        formdata.append('cover_image[' + i + ']', file);
    }
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"brand/store",this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        }   
        this.$router.push({ name: 'Brand', params: { id:response.data.id } })  
      
    },
  	
  }
};
</script>

<style lang="css" scoped>
</style>